import { AdminPanelHeader, SideBar } from 'components';
import useApiManager from 'networking/ApiManager';
import React, { useEffect, useMemo } from 'react';
import { useState } from 'react';
import { unstable_HistoryRouter, useLocation, useNavigate, useParams } from 'react-router-dom';
import 'whealth-core-web/components/prescription.scss';
import { useGetLoginUserDataQuery } from 'redux/apiSlice';
import { useGetCockpitDataQuery } from 'redux/cockpitSlice';
import { profileImage } from 'whealth-core-web/components/Helper';
import { pdf } from '@react-pdf/renderer';
import OPDReportPDF from 'whealth-core-web/components/PrescriptionPdf/Content';
import {
  Select2DropDown,
  AddPafForm,
  EditPafForm,
  CommonAlert,
  Loader,
  CoreInputBox,
  CoreButton,
} from 'whealth-core-web/components';
import InformationViewCard from './InformationViewCard';
import { Modal,Button, ButtonToolbar, Placeholder } from 'rsuite';
import { EllipsisVertical, Menu, TriangleAlert } from 'lucide-react';
import { set } from 'rsuite/esm/utils/dateUtils';
import { useSearchParams } from "react-router-dom";


function AddPaf() {
  const location = useLocation();
  const duplicateId = location?.state?.id;
  const navigation = useNavigate();
  const ApiClient = useApiManager();
  const { id, pid } = useParams();
  let userData = useGetLoginUserDataQuery()?.data?.data || {};
  const navigate = useNavigate();
  const [showDialog, setShowDialog] = useState(false);
  const [patientDetails, setPatientDetails] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const [openNoPrescriptionModal, setOpenNoPrescriptionModal] = useState(false);
  const [dynamicPerscriptionData, setDynamicPerscriptionData] = useState('');
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [errors, setErrors] = useState({ prescription_medicines: [] });
  const [alertType, setAlertType] = useState('alert-success');
  const [prescriptionData, setPrescriptionData] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [selectedDoctor, setSelectedDoctor] = useState('');
  const [departmentName, setDepartmentName] = useState('');
  const [departmentList, setDepartmentList] = useState([]);
  const [doctorList, setDoctorList] = useState([]);
  const [defaultDepartmentData, setDefaultDepartmentData] = useState([]);

  const [mandatoryMedicine, setMandatoryMedicine] = useState(false);
  const [departmentApi, setDepartmentApi] = useState(false);
  const [pdfModal, setPdfModule] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');
  const [printId, setPrintId] = useState('');
  const [clinic , setClinic] = useState([]);
  const [selectedClinic, setSelectedClinic] = useState('');
   const [citiesList, setCitiesList] = useState([]);
   const [pafStatus, setPafStatus] = useState(0)

  const getCockpitData = useGetCockpitDataQuery();

  const [searchParams] = useSearchParams();

  const consultationId = searchParams.get("consultation_id");
  const param_doctorId = searchParams.get("doctor_id");
  const param_locationId = searchParams.get("location_id");

  useEffect(() => {
    if (param_locationId && param_doctorId) {
      const locationIdFromUrl = param_locationId ? Number(param_locationId) : null;
      setSelectedClinic(locationIdFromUrl);
    }
  }, [param_doctorId, param_locationId,doctorList]);

  useEffect(() => {
    if (param_doctorId) {
      setSelectedDoctor(Number(param_doctorId));
      setShowDialog(true);
    }
  }, [param_doctorId]);

  useEffect(() => {
    const doctorIdFromUrl = param_doctorId ? Number(param_doctorId) : null;
    if (doctorIdFromUrl && doctorList?.length > 0) {
      const selectedDoctorObj = doctorList.find(
        (doc) => Number(doc.id) === doctorIdFromUrl
      );
  
      if (selectedDoctorObj) {
        setSelectedDepartment(selectedDoctorObj.department_id || "");
        setDepartmentName(selectedDoctorObj.department_name || "");
  
        if (selectedDoctorObj.department_uuid) {
          handleDoctorDepartment(selectedDoctorObj.department_uuid);
          handleLocations(selectedDoctorObj.id);
        }
      }
    }
  }, [param_doctorId, doctorList]);

  // useEffect(() => {
  //   window.addEventListener('beforeunload', handleBeforeUnload);
  //   return () => {
  //     window.removeEventListener('beforeunload', handleBeforeUnload);
  //   };
  // }, []);

  const handleBeforeUnload = (e) => {
    e.preventDefault();
    const message = 'Are you sure you want to leave? All provided data will be lost.';
    e.returnValue = message;
    return message;
  };

  useEffect(() => {
    let isEql = dynamicPerscriptionData?.department?.id == userData?.department?.id;
    if (dynamicPerscriptionData?.department?.id) {
      setSelectedDepartment(dynamicPerscriptionData?.department?.id);
    } else if (userData?.department?.id && !param_doctorId) {
      setSelectedDepartment(userData?.department?.id);
      setSelectedDoctor(userData?.id);
    }

    if(dynamicPerscriptionData?.clinic?.id){
      setSelectedClinic(dynamicPerscriptionData?.clinic?.id)
    }
    
    if(userData?.role == 'doctor'){
      setClinic(userData?.locations)
    }

  }, [userData, dynamicPerscriptionData?.department?.id]);

  useEffect(() => {
    getPrescriptionDepartment();
    getAllDoctor();
    getPatientData();
    getCitiesList();
  }, []);

  const getPrescriptionDepartment = () => {
    ApiClient.prescriptionDepartments(id)
      .then((res) => {
        setDepartmentList(res.data);
      })
      .catch((err) => {});
  };

  const getAllDoctor = () => {
    ApiClient.getAllDoctor(id)
      .then((res) => {
        setDoctorList(res.data);
      })
      .catch((err) => {});
  };

  const getCitiesList = () => {
    ApiClient.getClinics()
      .then((res) => {
        setCitiesList(res?.data?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getPatientData = () => {
    setIsLoading(true);
    ApiClient.getPatientDetails(id)
      .then((res) => {
        setIsLoading(false);
        setPatientDetails(res.data);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };


  const handleDoctorDepartment = (department_id) => {
    console.log('location',location)
    if (Object.keys(defaultDepartmentData).length) {
      getPrescriptionSchema(department_id, defaultDepartmentData);
    } else if (!location?.state?.id) {
      getDefaultPrescriptionData(department_id);
    }
  };

  const handleLocations = (doctor_id) => {
    console.log(doctor_id)
    let params = {}
    ApiClient.getLocationByAdmin(doctor_id, params)
    .then((res) => {
      console.log(res.data)
      setIsLoading(false);
      setClinic(res.data);
    })
    .catch((err) => {
      setIsLoading(false);
    });


  }

  const getDefaultPrescriptionData = (department_id) => {
    setIsLoading(true);
    ApiClient.getPublishedPrescriptionData(id)
      .then((res) => {
        setIsLoading(false);
        setDefaultDepartmentData(res.data);
        getPrescriptionSchema(department_id, res.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };





  useEffect(() => {
    if (pid) {
      getPrescriptionData();
    } else if (duplicateId) {
      getPrescriptionData(duplicateId);
    }
  }, [pid, duplicateId]);

  const filterDefaultData = (data, key, getIndex) => {
    let newData = {};
    let itemIndex;

    if (data) {
      data?.map((item, index) => {
        if (item.name == key) {
          newData = item;
          itemIndex = index;
        }
      });
    }

    if (getIndex) {
      return itemIndex;
    } else {
      return newData;
    }
  };

  const getPrescriptionSchema = (departmentID, data) => {
    let filterData = filterDefaultData(data.data, 'diagnosis');
    let ans = filterData?.answer;

    let params = { uuid: departmentID || userData?.department?.uuid };
    if (data?.isUpdate == true) {
      var pids = null;
    } else {
      var pids = pid || duplicateId;
    }
    setIsLoading(true);
    ApiClient.prescriptionSchema(id, pids, params)
      .then((res) => {
        let prescriptionSchemaData = res.data;
        let filterDataIndex = filterDefaultData(prescriptionSchemaData.prescription_schema, 'primary_diagnosis', true);
        if (
          ans &&
          prescriptionSchemaData?.prescription_schema &&
          prescriptionSchemaData.prescription_schema[filterDataIndex] &&
          !prescriptionSchemaData.prescription_schema[filterDataIndex].answer
        ) {
          prescriptionSchemaData.prescription_schema[filterDataIndex].answer = ans;
        }

        if (prescriptionSchemaData?.enable_medicine) {
          if (mandatoryMedicine) {
            prescriptionSchemaData.prescription_medicines = [
              {
                dosage: '000',
                medicine_id: '',
                duration: 0,
                frequency: '',
                note: '',
                medicine: { name: '' },
              },
            ];
          } else {
            prescriptionSchemaData.prescription_medicines = [];
          }
        }
        setDynamicPerscriptionData(prescriptionSchemaData);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const getPrescriptionData = (paf_id = pid) => {
    setIsLoading(true);
    ApiClient.pafData(id, paf_id)
      .then((res) => {
        setIsLoading(false);
        setPrescriptionData(res.data);
        if(res.data){
          setPafStatus(res.data.status)
        }
        if(res.data.clinic){
          setSelectedClinic(res.data.clinic)
        }
        if (!!Object.entries(res.data?.data).length) {
          let tmpData = res.data;
          tmpData.prescription_schema = res.data.data;
          tmpData.isUpdate = true;
          let checkInDateIndex = tmpData.prescription_schema.findIndex((item2) => item2.name === 'next_followup_date');
          if (checkInDateIndex != -1 && !pid) {
            tmpData.prescription_schema[checkInDateIndex].answer = '';
          }
          console.log('******tmpData', tmpData);
          setDynamicPerscriptionData(tmpData);
        } else {
          setPrescriptionData(res.data);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const updatePafData = (data) => {
    setIsLoading(true);
    data.id = pid
    ApiClient.updatePaf(id, pid, data)
      .then((res) => {
        setIsLoading(false);
        setAlertType('alert-success');
        setIsShowAlert('Paf updated successfully ');
        // setTimeout(() => {
        //   window.close();
        // }, 1500);
      })
      .catch((err) => {
        setIsLoading(false);
        setErrors(err.response.data.errors);
        if (err.response.data?.errors?.non_field_errors || err.response.data?.errors?.details) {
          setAlertType('alert-danger');
          setIsShowAlert(Object.values(err.response.data?.errors?.non_field_errors || err.response.data.errors)[0]);
        }
      });
  };

  const savePaf = (data) => {
    setIsLoading(true);
    data.clinic = selectedClinic
    data.department = selectedDepartment;
    data.doctor = selectedDoctor;
    data.consultation_id = consultationId;
    data.user = id

    ApiClient.savePaf(data)
      .then((res) => {
        setIsLoading(false);
        setAlertType('alert-success');
        setIsShowAlert('PAF created successfully ');
        console.log("response : ",res)
        if (res?.data?.id) {
          console.log("res")
          setTimeout(() => {
            navigation(`/patient/${id}/paf/${res?.data?.id}?view=1`);
          }, 2500);
        }
       
        // setTimeout(() => {
          // window.close();
        // }, 1500);
      })
      .catch((err) => {
        console.warn('er', err);

        setIsLoading(false);
        setErrors(err.response.data.errors);
        if (err.response.data?.errors?.non_field_errors || err.response.data?.errors?.details) {
          setAlertType('alert-danger');
          setIsShowAlert(Object.values(err.response.data?.errors?.non_field_errors || err.response.data.errors)[0]);
        }
      });
  };
  const closeModalPdf = (item) => {
    setPdfModule(!pdfModal);
  };

  const openModalPdf = async (pres_id) => {
    setPrintId(pres_id);
    if (!pdfModal) {
      setIsLoading(true);
      try {
        const res = await ApiClient.prescriptionPdfDownload(id, pres_id);
        console.log(res);
        let blobURL= ''
        // Generate PDF blob
        if(res.data){
          const blob = await pdf(<OPDReportPDF data={res.data} />).toBlob();
          blobURL = URL.createObjectURL(blob);
        }
        
  
        setPdfUrl(blobURL);
        setPdfModule(!pdfModal);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        console.error(err);
      }
    }
  };

  const pafUpdateStatus = (itemId) => {
      setIsLoading(true);
      // seterror({});
      const data = {
        id: itemId
      };
      ApiClient.updatePafStatus(data)
        .then((res) => {
          setIsLoading(false);
          console.log(res);
          setAlertType('alert-success');
          setIsShowAlert('Paf Linked to next prescription successfully.');
          getPrescriptionData();
        })
        .catch((err) => {
          setIsLoading(false);
          if (err.response.status == 500) {
            setIsShowAlert('Internal server error');
          } else {
            setIsShowAlert(err.response.data.message);
          }
          setAlertType('alert-danger');
          setIsShowAlert(err.response.data.detail || err.response.data.message);
          console.log(err);
        });
    };



  const handlePublishAndPrint = () => {
    const windowConfirm = window.confirm(`Are you sure, you want to publish prescription?`);
    if (windowConfirm) {
      ApiClient.statusPublish(id, printId)
        .then((res) => {
          setIsLoading(false);
          setAlertType('alert-success');
          setIsShowAlert('Prescription Published successfully ');
          setTimeout(() => {
            navigation(`/patient/${id}/dashboard`);
          }, 1500);
          
        })
        .catch((err) => {
          setIsLoading(false);
        });
      setPdfModule(false);
    }
  };

  let userDetails = localStorage.getItem('userDetails');
  userDetails = JSON.parse(userDetails);

  const showTree = [
    // { iconClass: 'person_outline', title: 'Patient', link: '/patient' },
    {
      icon: profileImage(userDetails?.gender, userDetails?.image),
      title: userDetails?.name,
      link: ``,
    },
    { title: (pid ? 'Update' : 'New') + ' PAF', link: '' },
  ];

 

  const renderDoctorDropdown = () => {
    return (
      <div className='daypart-input behaviourpart_box w-100'>
        <Select2DropDown
          value={selectedDoctor}
          data={doctorList}
          labelKey='full_name'
          label={'Doctor'}
          placeholder={'Select Doctor'}
          valueKey='id'
          disabled={param_doctorId}
          getObjData
          retuired
          onSelect={(_, selectedValue) => {
            setSelectedDoctor(selectedValue?.id || '');
            setSelectedDepartment(selectedValue?.department_id || '');
            setDepartmentName(selectedValue?.department_name || '');
            if (selectedValue?.department_uuid) {
              handleDoctorDepartment(selectedValue?.department_uuid);
              handleLocations(selectedValue?.id);
            }
            setShowDialog(true);
          }}
          showMSG={''}
        />
      </div>
    );
  };

  const renderDepartmentDropdown = () => {
    return (
      <div className='daypart-input behaviourpart_box w-100'>
        <CoreInputBox
          disabled={true}
          // showMSG={medicineError?.name}
          placeholder='Department'
          value={departmentName || ''}
          label='Department Name'
          maxLength={255}
          msgStyle={{ color: 'red' }}
          retuired
        />

      </div>
    );
  };

 
  const showPatient = () => {
    const renderPage = () => {
      if (setSelectedClinic) {
          return (
                  <>
                    {pid && prescriptionData ? 
                      <EditPafForm
                        dynamicPerscriptionData={prescriptionData}
                        patientDetails={patientDetails}
                        setDynamicPerscriptionData={setDynamicPerscriptionData}
                        setErrors={setErrors}
                        selectedDepartment={selectedDepartment}
                        selectedDoctor={selectedDoctor}
                        selectedClinic={selectedClinic}
                        errors={errors}
                        onSave={pid ? updatePafData : savePaf}
                        pafUpdateStatus = {pafUpdateStatus}
                        setAlertType={setAlertType}
                        setIsShowAlert={setIsShowAlert}
                        isShowAlert={isShowAlert}
                        alertType={alertType}
                        userRole={userData?.role}
                        userDetails={userDetails}
                        citiesList={citiesList}
                        pid={pid}
                        pafStatus={pafStatus}
                        isNivanCareTeam
                      /> 
                    : 
                      <AddPafForm
                        dynamicPerscriptionData={prescriptionData}
                        patientDetails={patientDetails}
                        setDynamicPerscriptionData={setDynamicPerscriptionData}
                        setErrors={setErrors}
                        selectedDepartment={selectedDepartment}
                        selectedDoctor={selectedDoctor}
                        selectedClinic={selectedClinic}
                        errors={errors}
                        onSave={pid ? updatePafData : savePaf}
                        setAlertType={setAlertType}
                        setIsShowAlert={setIsShowAlert}
                        isShowAlert={isShowAlert}
                        alertType={alertType}
                        userRole={userData?.role}
                        userDetails={userDetails}
                        citiesList={citiesList}
                        isNivanCareTeam
                      /> 
                    }
                    
                  </>
                  
                
          );
        
      }
    };
    return (
      <>
        <div className='teamHeader stickyPafHeader'>
          {/* <div className='headerFiles'>
            <AdminPanelHeader iconTitle='person_outline' showTree={showTree} title='Patient' />
          </div> */}
          <div className='addnewform-part'>{pid ? 'Update' : 'Add New'} PAF</div>
          <div className='hrLine' />
        </div>
        <div className='px-4' style={{"margin-left":"2%" , "margin-right":"2%"}}>
          {isShowAlert && alertType == 'alert-success' && (
            <div className='mt-5'>
              <CommonAlert isShowAlert={isShowAlert} alertType={alertType} setIsShowAlert={setIsShowAlert} />
            </div>
          )}
          {userData?.role != 'doctor' && !pid && !duplicateId && doctorList?.length ? (
            <div className='card mt-3 d-flex flex-row gap-4 justify-content-between'>
              <div className='card-body'>{renderDoctorDropdown()}</div>
              <div className='card-body'>
                <div className='daypart-input behaviourpart_box w-100'>
                    <Select2DropDown
                        value={selectedClinic}
                        data={clinic}
                        labelKey='name'
                        label={'Clinic'}
                        placeholder={'Clinic'}
                        valueKey='id'
                        getObjData
                        retuired
                        disabled={param_doctorId}
                        onSelect={(_, selectedValue) => {
                          setSelectedClinic(selectedValue?.id || '');
                        }}
                        showMSG={''}
                      />
                </div>
              </div>
              <div className='card-body'>{renderDepartmentDropdown()}</div>
            </div>
          ) : 
          (!pid && !duplicateId && doctorList?.length ) ? 
            <div className='card mt-3 d-flex flex-row gap-4 justify-content-between'>
              <div className='card-body'>
                    <div className='daypart-input behaviourpart_box w-100'>
                        <Select2DropDown
                            value={selectedClinic}
                            data={clinic}
                            labelKey='name'
                            label={'Clinic'}
                            placeholder={'Clinic'}
                            disabled={param_doctorId}
                            valueKey='id'
                            getObjData
                            retuired
                            onSelect={(_, selectedValue) => {
                              setSelectedClinic(selectedValue?.id || '');
                            }}
                            showMSG={''}
                          />
                    </div>
                  </div>
              </div>
              : 
              <div className='card mt-3 d-flex flex-row gap-4 justify-content-between' >
                  <div className='card-body'>
                    <div className='row'>
                      <div className='col-md-5'>Doctor : {prescriptionData?.doctor_details?.full_name}</div>
                      <div className='col-md-2'></div>
                      <div className='col-md-5'>Clinic : {prescriptionData?.clinic_details?.name}</div>
                    </div>
                  </div>
              </div>
          }

          {selectedClinic ? renderPage() : null}
          <Modal backdrop='static' size='lg' open={pdfModal} onClose={closeModalPdf}>
            <Modal.Header>
              <Modal.Title>Prescription View</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <iframe src={pdfUrl + '#toolbar=0'} onContextMenu='return false;' width={'100%'} height={window.innerHeight} />
            </Modal.Body>
            <Modal.Footer className='mt-4'>
              <span style={{ float: 'left' }}>
                <CoreButton
                  onClick={() => {
                    setPdfModule(!pdfModal);
                    navigate(`/patient/${id}/prescriptions/${printId}/edit`, { state: { id: printId } });
                  }}
                  title='Back to editing Prescription'
                  customClass='btn btn-md newCoreBtn'
                  core_remove={1}
                />
               
              </span>

              <Button onClick={handlePublishAndPrint} appearance='primary'>
                Publish
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal backdrop='static' size='sm' open={openNoPrescriptionModal} onClose={() => setOpenNoPrescriptionModal(false)}>
            <Modal.Header>
              <Modal.Title className='text-center'>
                <TriangleAlert style={{ height: '40px', width: '40px' }} />
                <br />
                <p className='mt-2'>Are you sure there will be no prescription for this patient?</p>
              </Modal.Title>
            </Modal.Header>
            <Modal.Footer className='mt-4'>
              <Button onClick={() => setOpenNoPrescriptionModal(false)} style={{ width: '80px' }} appearance='primary' color='red'>
                No
              </Button>

             
            </Modal.Footer>
          </Modal>
        </div>
      </>
    );
  };

  return (
    <div className='wrapper'>
      {showPatient()}
      <Loader show={isLoading} />
    </div>
  );
}

export default AddPaf;
